const featuresPay = {
    featureTitle: 'Ra Quyết Định Kinh Doanh Dựa Trên Dữ Liệu',
    featureDescription:
        'Biết mặt hàng nào bán chạy nhất và mang lại lợi nhuận cao nhất, truy cập báo cáo tài chính bất cứ lúc nào, bất cứ nơi đâu. Doanh nghiệp của bạn trong lòng bàn tay!',
    featureButton: "Gói Premium",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'Chỉ từ',
    featureEndingText: 'Nghìn',

    features: [
        {
            title: 'Không Giới Hạn Sản Phẩm',
            description: 'Thêm tất cả sản phẩm bạn có mà không bị giới hạn số lượng.'
        },
        {
            title: 'Không Giới Hạn Nhân Viên',
            description: 'Thêm Nhân viên/Quản trị viên vào doanh nghiệp mà không giới hạn.'
        },
        {
            title: 'Không Giới Hạn Lịch Sử',
            description: 'Xem thay đổi trong hồ sơ tồn kho cũ mà không giới hạn.'
        },
        {
            title: 'Lọc Lịch Sử',
            description: 'Dễ dàng xem lịch sử theo loại, danh mục, nhân viên và ngày.'
        },
        {
            title: 'Tải Xuống Excel',
            description: 'Lấy lịch sử hồ sơ tồn kho vào Microsoft Excel chỉ với một cú click.'
        },
        {
            title: 'Tải Xuống PDF',
            description: 'Lấy danh sách sản phẩm và tồn kho mới nhất vào PDF chỉ với một cú click.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Tạo nhiều kho hàng để quản lý tồn kho tốt hơn.'
        },
        {
            desc: 'Phân bổ sản phẩm vào các vị trí cụ thể.'
        },
        {
            desc: 'Theo dõi mức tồn kho tại các kho hàng khác nhau.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Thêm biến thể kích cỡ, màu sắc hoặc chất liệu.' },
        { desc: 'Đặt mức tồn kho cho từng biến thể.' },
        { desc: 'Theo dõi tồn kho qua các kho hàng.' }
    ]
}
export default featuresPay